module.exports = __webpack_public_path__ + "static/media/caribbean_mob.7b190203.png";